import { Injectable } from '@angular/core';
import {
  IGenerateWarranty, IGetGenerateWarrantyBody, IOrderInquiry, IGetRelatedServiceOrderBody, IGetInvoiceBody, IInvoiceInquiry,
  IGetOrderInvoiceDetailsBody, IGetOrderShipmentDetailsBody, IUser, IGetOrdersInquiryBody, IGetOrdersDetailsBody, ICustomer, IGetInvoiceDetailsBody
  , BaseResponse
} from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable, empty } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GenerateWarrantyService {

  constructor(private httpClient: HttpClient) { }

  public get readUserObject(): IUser {
    return JSON.parse(localStorage.getItem('user')) as IUser;
  }

  public getDetailsOfServiceOrder(body: IGetRelatedServiceOrderBody): Observable<Array<IGenerateWarranty>> {
    const endPoint = `${ConfigService.APIs.endPoints.GENERATEWARRANTY.GET_DETAILS_OF_SERVICE_ORDER}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public getOrders(body: IGetGenerateWarrantyBody): Observable<Array<IGenerateWarranty>> {
    body.customerNumber = this.readUserObject.customerNumber;

    const endPoint = `${ConfigService.APIs.endPoints.GENERATEWARRANTY.GET_ORDERS_FOR_WARRANTY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data.map((item: IGenerateWarranty) =>
        ({
          billTo: item.billTo, jobName: item.jobName, jobNumber: item.jobNumber, orderBu: item.orderBu, orderDate: item.orderDate, orderDateAsDate: new Date(item.orderDateUIString),
          orderDateUIString: item.orderDateUIString, serviceOrderNumber: item.serviceOrderNumber, poNumber: item.poNumber, workmanship: item.workmanship, finishedWarranty: item.finishedWarranty,
          scheduleDate: item.scheduleDate, scheduleDateAsDate: new Date(item.scheduleDateUIString), shipFrom: item.shipFrom, shipTo: item.shipTo, scheduleDateUIString: item.scheduleDateUIString
        } as IGenerateWarranty)))
      )

  }

  public downloadWarranty(body: IGetGenerateWarrantyBody): Observable<any> {
    const languageCode = localStorage.getItem('language');
    if (languageCode.toLowerCase() == "fre") {
      body.isFrench = true;
    }
    const endPoint = `${ConfigService.APIs.endPoints.GENERATEWARRANTY.DOWNLOAD_WARRANTY}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

}
